import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const CntrSizeTypeAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();

    const hideCntrType = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        if (chargeTypeList.length > 0) {
            const excludeType = ['GI', 'EMP', 'CYVC', 'AUC', 'VGM', 'CC', 'COD', 'COV', 'DOC'];
            const ret2 = chargeTypeList.some(type => excludeType.includes(type));
            if (ret2) {
                return true;
            }
        }
        return false;
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    const hideCntrSize = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const excludeType = ['EMP', 'CYVC', 'AUC', 'CC', 'COD', 'COV', 'DOC', 'HDL'];
        if (chargeTypeList.length > 0) {
            const ret = chargeTypeList.some(type => excludeType.includes(type));
            if (ret) {
                return true;
            }
        }
        return false;
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                {!hideCntrSize && <>
                    <div className='im-flex-row-item' style={{ width: "150px" }}>
                        <NbisCommonField
                            errorMessages={{}}
                            isReadOnly={false}
                            isShowOptional={false}
                            readOnlyValue={chargeBatchUpdate.size ?? ""}
                            fieldValue={chargeBatchUpdate.size}
                            fieldLabel={"Size"}
                            isSaveClicked={false}
                            fieldType={FieldType.DROPDOWN}
                            fieldKey={'size'}
                            maxLength={60}
                            options={chargeDetailState.dynamicOptions.sizeGroupDropdownOptions}
                            requiredFieldList={[]}
                            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                                chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                    </div>
                </>}

                {!hideCntrType && <>
                    <div className='im-flex-row-item' style={{ width: "150px" }}>
                        <NbisCommonField
                            errorMessages={{}}
                            isReadOnly={false}
                            isShowOptional={false}
                            readOnlyValue={chargeBatchUpdate.cntrType ?? ""}
                            fieldValue={chargeBatchUpdate.cntrType}
                            fieldLabel={"Type"}
                            isSaveClicked={false}
                            fieldType={FieldType.DROPDOWN}
                            fieldKey={'cntrType'}
                            maxLength={60}
                            options={chargeDetailState.dynamicOptions.typeDropdownOptions}
                            requiredFieldList={[]}
                            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                                chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                    </div>
                </>}
            </div>
        </>
    )
}